import CtaArrow from "@/components/svg/CtaArrow";
import { getBlogComponents } from "@/helpers";
import { PrismicNextLink } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.BlogSliceCardPrimary} CardPrimary
 * @param {{ primary: CardPrimary }} props
 */
const Card = ({ primary }) => (
  <div>
    <div className="flex flex-col gap-10 bg-bleu px-[30px] py-10 rounded-[20px]">
      <div className="flex flex-col">
        <PrismicRichText
          field={primary.title}
          components={{
            heading2: ({ children }) => <h2 className="h3-n text-white">{children}</h2>,
          }}
        />
        <PrismicRichText
          field={primary.text}
          components={getBlogComponents({ color: "white", highlightColor: "beige" })}
        />
      </div>

      <PrismicNextLink
        prefetch={false}
        field={primary.cta}
        className="cta cta-text text-white flex w-full md:w-fit flex-row gap-5 bg-vert relative"
      >
        {primary.cta.text}
        <CtaArrow className="text-white" />
      </PrismicNextLink>
    </div>
  </div>
);

export default Card;
